<template>
  <div id="feedback">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px">
              <el-form-item :label="$t('interaction.feedbackType')" >
                <el-select v-model="filterForm.businessSystem" :placeholder="$t('interaction.chooseFeedbackType')" clearable>
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.key"
                    :label="item.key"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('interaction.startTime')" >
                <el-date-picker
                  style="width: 100%"
                  v-model="filterForm.startDate"
                  type="date"
                  :placeholder="$t('survey.startTime')"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('interaction.endTime')" >
                <el-date-picker
                  style="width: 100%"
                  v-model="filterForm.endDate"
                  type="date"
                  :placeholder="$t('survey.endTime')"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="20">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
                  <!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="filterBtns">
                  <el-button type="primary" @click="exportData">{{ $t('export') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table :data="tableData" v-loading="tableLoading">
              <el-table-column sortable prop="businessSystem" :label="$t('interaction.feedbackType')"></el-table-column>
              <el-table-column sortable prop="content" :label="$t('interaction.feedbackContent')"></el-table-column>
              <el-table-column sortable prop="createTime" :label="$t('interaction.feedbackTime')"></el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Popup',
  components: {
  },
  data: function () {
    return {
      filterForm: {
        businessSystem: '', // 反馈类型
        startDate: '', // 开始时间
        endDate: '', // 结束时间
      },
      initFilterForm: {
        businessSystem: '', // 反馈类型
        startDate: '', // 开始时间
        endDate: '', // 结束时间
      },
      loading: false,
      tableData: [], // 表格数据
      total: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
      typeOptions: []
    }
  },
  mounted () {
    this.getTypeOptions()
  },

  methods: {
    async getTypeOptions() {
      let res = await window.instance.post(window.retailinkUrl + '/mqApi/systemType')
      res = res.data
      if (res.code === 200) {
        this.typeOptions = _.map(res.data, (type) => ({
          key: type.desc,
          value: type.code
        }))
      }
    },
    onReset() {
      // 重置
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },

    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      let res = await window.instance.post(window.retailinkUrl + '/feedback/listFeedback', _.assign(this.filterForm, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.records
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
    exportData: async function () {
      let { data, fileName } = await this.$tool.exportFile({
        method: "post",
        url: window.retailinkUrl + "/feedback/feedbackExport",
        data: this.filterForm
      });
    }
  }
}
</script>

<style scoped lang="sass">
#feedback

</style>



// WEBPACK FOOTER //
// src/pages/interaction/feedback.vue